const asyncActionType = type => ({
    pending: `${type}_PENDING`,
    success: `${type}_SUCCESS`,
    error: `${type}_ERROR`
});

export const SU_ADD_PROPERTY = asyncActionType('SU_ADD_PROPERTY');
export const SU_DELETE_PROPERTY = asyncActionType('SU_DELETE_PROPERTY');
export const CHANNEL_MAPPING = asyncActionType('CHANNEL_MAPPING');
export const LOAD_MAPPING_DATA = asyncActionType('LOAD_MAPPING_DATA');